<template>
  <div class="card">
    <div class="card-header">
      <strong>Relatório de disponibilidade</strong>
      <small>Atualizado a cada 5 minutos</small>
    </div>
    <div class="card-body">
      <b-table hover :items="items" :fields="fields"></b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Relatorio",
  data() {
    return {
      interval: "",
      fields: [
        { key: "descricaoConta", sortable: true },
        { key: "numero", sortable: true },
        { key: "percentualBateria", sortable: true },
        { key: "comInternet", sortable: true },
        { key: "velocidadeConexao", sortable: true },
        { key: "quantidadeLicencas", sortable: true, label: "Acessos" },
        { key: "value", sortable: true, label: "Robô" },
        { key: "difEnv", sortable: true, label: "Envio" },
        { key: "difRec", sortable: true, label: "Recebimento" }
      ],
      items: []
    };
  },
  mounted() {
    let vm = this;
    this.carregarDados(false);
    this.interval = setInterval(function () {
      vm.carregarDados(false);
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    // rowClass(item, type) {
    //   if (!item || type !== "row") return;
    //   if (item.value > 60) return "table-danger";
    //   else if (item.value > 15) return "table-warning";
    //   else return "table-success";
    // },
    carregarDados(inverter) {
      this.$http({
        url: "grafico/obter-dados-telefone/" + inverter,
        method: "GET"
      }).then((resp) => {
        resp.data.forEach((element) => {
          element.difRobo = Math.round(
            (Date.now() - new Date(element.dataAlteracao)) / 60000
          );
          element.difEnv = Math.round(
            (Date.now() - new Date(element.dataUltimoEnvio)) / 60000
          );
          element.difRec = Math.round(
            (Date.now() - new Date(element.dataUltimoRecebimento)) / 60000
          );
          element._cellVariants = {
            difEnv:
              element.difEnv > 59
                ? "danger"
                : element.difEnv > 29
                ? "warning"
                : "success",
            difRec:
              element.difRec > 59
                ? "danger"
                : element.difRec > 29
                ? "warning"
                : "success",
            value:
              element.value > 59
                ? "danger"
                : element.value > 29
                ? "warning"
                : "success"
          };
        });
        this.items = resp.data;
      });
    }
  }
};
</script>
